import { render, staticRenderFns } from "./CalendarEventSlotsForm.vue?vue&type=template&id=4cfa2e3a&scoped=true"
import script from "./CalendarEventSlotsForm.vue?vue&type=script&lang=js"
export * from "./CalendarEventSlotsForm.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventSlotsForm.vue?vue&type=style&index=0&id=4cfa2e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa2e3a",
  null
  
)

export default component.exports